var searchSuggestTimeout = 0;
var suggestlistItems = null;
var searchcurrentLI = 0;

function autoComplete(q)
{
  fetch(`https://spo-partner-api.azure-api.net/suggest?term=${q}&count=10&Subscription-Key=662cff71ce7d49088924abf032a0785c`)
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {
    if (data.length > 0)
    {
      $("#shoppingAssistantSuggest").hide();
      $("#imageSearchSuggest").hide();
      $("#colorPickSuggest").hide();
      let arr = [];
      let keyval = data.filter(it => it.searchField == "Brand");
      for (let x = 0; x < keyval[0].value.length; x++)
      {
        if (!arr.includes(keyval[0].value[x].queryPlusText))
          arr.push(keyval[0].value[x].queryPlusText)
      }
      if (arr.length < 10)
      {
        keyval = data.filter(it => it.searchField == "BrandCategory");
        for (let x = 0; x < keyval[0].value.length; x++)
        {
          if (!arr.includes(keyval[0].value[x].queryPlusText))
            arr.push(keyval[0].value[x].queryPlusText)
        }
      }
      if (arr.length < 10)
      {
        keyval = data.filter(it => it.searchField == "Category/Title");
        for (let x = 0; x < keyval[0].value.length; x++)
        {
          if (!arr.includes(keyval[0].value[x].queryPlusText))
            arr.push(keyval[0].value[x].queryPlusText)
        }
      }
      if (arr.length < 10)
      {
        keyval = data.filter(it => it.searchField == "Title");
        for (let x = 0; x < keyval[0].value.length; x++)
        {
          if (!arr.includes(keyval[0].value[x].queryPlusText))
            arr.push(keyval[0].value[x].queryPlusText)
        }
      }
      if (arr.length > 0)
      {
        $(".gray-overlay").show();
        $(".close-search").show();
        $(".search-mag-icon").hide();
        let lis = "";
        for (let x = 0; x < arr.length; x++) {
          lis += `<li tabindex='0' class='search-prediction' onclick='suggestionClick(this);' data-type="term" data-value="${arr[x]}">
          <svg style="margin-right: 16px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.04606C0 3.16097 3.16097 0 7.04606 0C10.9314 0 14.0921 3.16097 14.0921 7.04606C14.0921 8.75506 13.4806 10.3239 12.4649 11.5452L15.8094 14.8897C16.0635 15.1436 16.0635 15.5556 15.8094 15.8094C15.6824 15.9365 15.5159 16 15.3496 16C15.1831 16 15.0168 15.9365 14.8897 15.8094L11.5452 12.4649C10.3239 13.4806 8.75506 14.0921 7.04606 14.0921C3.16097 14.0921 0 10.9314 0 7.04606ZM1.30081 7.04609C1.30081 10.214 3.87816 12.7913 7.04606 12.7913C10.214 12.7913 12.7913 10.214 12.7913 7.04606C12.7913 3.87816 10.214 1.30081 7.04606 1.30081C3.87816 1.30081 1.30081 3.87819 1.30081 7.04609Z" fill="black"/>
          </svg>
          <div class='search-panel-text'>${arr[x]}</div>
          </li>`;
          if (x==4)
            break;
        }
        lis += `<li tabindex='0' class='search-prediction' onclick='suggestionClick(this);' data-type="term" data-value="${q}">
        <svg style="margin-right: 16px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.04606C0 3.16097 3.16097 0 7.04606 0C10.9314 0 14.0921 3.16097 14.0921 7.04606C14.0921 8.75506 13.4806 10.3239 12.4649 11.5452L15.8094 14.8897C16.0635 15.1436 16.0635 15.5556 15.8094 15.8094C15.6824 15.9365 15.5159 16 15.3496 16C15.1831 16 15.0168 15.9365 14.8897 15.8094L11.5452 12.4649C10.3239 13.4806 8.75506 14.0921 7.04606 14.0921C3.16097 14.0921 0 10.9314 0 7.04606ZM1.30081 7.04609C1.30081 10.214 3.87816 12.7913 7.04606 12.7913C10.214 12.7913 12.7913 10.214 12.7913 7.04606C12.7913 3.87816 10.214 1.30081 7.04606 1.30081C3.87816 1.30081 1.30081 3.87819 1.30081 7.04609Z" fill="black"/>
        </svg>
        View All Results
        </li>`
        $("#searchSuggestionsUL").html(lis).show();
        $("#searchSuggestions").show();
        $(".searchSuggestTitle").hide();
        suggestlistItems = document.querySelectorAll(".searchSuggestionsUL li");

        if (window.innerWidth < 767) {
          $("#searchSuggestionsULMobile").html(lis).show();
          $("#searchSuggestionsMobile > #shoppingAssistantSuggest").hide();
          $("#searchSuggestionsMobile > #imageSearchSuggest").hide();
          $("#searchSuggestionsMobile > #colorPickSuggest").hide();
          suggestlistItems = document.querySelectorAll(".searchSuggestionsULMobile li");
        }

        searchcurrentLI = -1;
      }
    }
  });
}
function recentSearchesClear() {
  localStorage.removeItem("recentSearches");
  $("#searchSuggestionsUL").html("").hide();
  $("#searchSuggestionsULMobile").html("").hide();
  $(".searchSuggestTitle").hide();
  $("#searchPopParent").hide();
  $("#searchSuggestions").hide();
  $(".gray-overlay").hide();
  $(".close-search").hide();
  $(".close-search-mobile").hide();
  $(".search-mag-icon").show();
}

function mobileSearchInputClear() {
  $("#qMobile[name='q']").val('');
  $("#searchSuggestionsULMobile").hide();
  $(".close-search-mobile").hide();
  $("#searchSuggestionsMobile > #shoppingAssistantSuggest").show();
  $("#searchSuggestionsMobile > #imageSearchSuggest").show();
  $("#searchSuggestionsMobile > #colorPickSuggest").show();
  recentSearchesLoad();
}

function isJSON(str) {
    try {
        return JSON.parse(str) && !!str;
    } catch (e) {
        return false;
    }
}
function recentSearchesLoad() {
  let s = localStorage.getItem("recentSearches") == null ? "" : localStorage.getItem("recentSearches");
  if (s != "" && isJSON(s)) 
  {
    s=JSON.parse(s).reverse();
    let lis = "";
    $("#searchPopParent").show();
    $("#searchSuggestions").show();
    $(".searchSuggestTitle").show();
    $(".gray-overlay").show();
    $(".close-search").show();
    $("#shoppingAssistantSuggest").show();
    $("#imageSearchSuggest").show();
    $("#colorPickSuggest").show();
    $(".search-mag-icon").hide();

    if (window.innerWidth < 767) {
      $('body').css('overflow', 'hidden');
      $("#mobileSearchPanel").show();
            
      setTimeout(function() {
        $("#qMobile[name='q']").get(0).focus();
      }, 0);
    }

    if (s.length > 4) {
      s = s.slice(0, 5)
    }

    s.forEach((item) => 
    {      
      switch(item.type)
      {
        case "term":
          let tv = item.value.toLowerCase();
          const xssRegex = /<[^>]*>|on\w+=|javascript:/i;

          if (xssRegex.test(tv))
            break;
          lis += `<li tabindex='0' onclick='suggestionClick(this);' data-type="${item.type}" data-value="${item.value}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="history-icon-search">
          <g clip-path="url(#clip0_16354_1273)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 8C15.25 12 12 15.25 8 15.25C4.0125 15.25 0.75 12 0.75 8C0.75 7.7875 0.9125 7.625 1.125 7.625C1.3375 7.625 1.5 7.7875 1.5 8C1.5 11.5875 4.4125 14.5 8 14.5C11.5875 14.5 14.5 11.5875 14.5 8C14.5 4.4125 11.5875 1.5 8 1.5C6.2875 1.5 4.675 2.1625 3.4625 3.3625H4.3C4.5125 3.3625 4.675 3.525 4.675 3.7375C4.675 3.95 4.5125 4.1125 4.3 4.1125H2.5C2.2875 4.1125 2.125 3.95 2.125 3.7375V1.95C2.125 1.7375 2.2875 1.575 2.5 1.575C2.7125 1.575 2.875 1.7375 2.875 1.95V2.875L2.8875 2.8625C4.2375 1.5 6.0625 0.75 8 0.75C12 0.75 15.25 4 15.25 8ZM10.0658 10.5806L7.48597 8.64576C7.3931 8.57095 7.33333 8.44239 7.33333 8.29964V4.42996C7.33333 4.19241 7.52574 4 7.7633 4C8.00085 4 8.19326 4.19241 8.19326 4.42996V8.08466L10.5817 9.89266C10.7718 10.0352 10.8102 10.3046 10.6677 10.4946C10.5252 10.6847 10.2558 10.7231 10.0658 10.5806Z" fill="#626262"/>
          </g>
          <defs>
            <clipPath id="clip0_16354_1273">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <div class='search-panel-text'>${item.value}</div>
        <div class="remove-recent-search" data-value="${item.value}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M13.6594 2.34065C10.5379 -0.780218 5.46155 -0.780218 2.34009 2.34065C-0.78003 5.46153 -0.78003 10.5393 2.34009 13.6602C3.90082 15.2203 5.95044 16 8.00009 16C10.0497 16 12.0987 15.2203 13.6594 13.6602C16.7802 10.5394 16.7802 5.46153 13.6594 2.34065ZM11.3009 10.3586C11.5617 10.6194 11.5617 11.0409 11.3009 11.3017C11.1709 11.4318 11.0001 11.4971 10.8294 11.4971C10.6586 11.4971 10.4879 11.4318 10.3578 11.3017L8.00005 8.9432L5.64295 11.301C5.51223 11.4311 5.34146 11.4965 5.17138 11.4965C5.00065 11.4965 4.82988 11.4311 4.69982 11.301C4.43904 11.0402 4.43904 10.618 4.69982 10.3579L7.05693 8.00008L4.69916 5.64227C4.43838 5.38149 4.43838 4.95928 4.69916 4.69915C4.95929 4.43837 5.38148 4.43837 5.64226 4.69915L8.00002 7.05696L10.3578 4.69915C10.6186 4.43837 11.0401 4.43837 11.3009 4.69915C11.5617 4.95928 11.5617 5.38149 11.3009 5.64227L8.94312 8.00008L11.3009 10.3586Z" fill="#BDBDBD"/>
          </svg>
        </div>
        </li>`;
          break;
        case "clr":
          let t = "Color match";
          let c = item.value.replace("%23","");
          if (item.value.indexOf("#") == -1)
          {
            c = getHexForColor(item.value);
            t="Color";
          }
          lis += `<li tabindex='0' onclick='suggestionClick(this);' data-type="${item.type}" data-value="${item.value}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="history-icon-search">
          <g clip-path="url(#clip0_16354_1273)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 8C15.25 12 12 15.25 8 15.25C4.0125 15.25 0.75 12 0.75 8C0.75 7.7875 0.9125 7.625 1.125 7.625C1.3375 7.625 1.5 7.7875 1.5 8C1.5 11.5875 4.4125 14.5 8 14.5C11.5875 14.5 14.5 11.5875 14.5 8C14.5 4.4125 11.5875 1.5 8 1.5C6.2875 1.5 4.675 2.1625 3.4625 3.3625H4.3C4.5125 3.3625 4.675 3.525 4.675 3.7375C4.675 3.95 4.5125 4.1125 4.3 4.1125H2.5C2.2875 4.1125 2.125 3.95 2.125 3.7375V1.95C2.125 1.7375 2.2875 1.575 2.5 1.575C2.7125 1.575 2.875 1.7375 2.875 1.95V2.875L2.8875 2.8625C4.2375 1.5 6.0625 0.75 8 0.75C12 0.75 15.25 4 15.25 8ZM10.0658 10.5806L7.48597 8.64576C7.3931 8.57095 7.33333 8.44239 7.33333 8.29964V4.42996C7.33333 4.19241 7.52574 4 7.7633 4C8.00085 4 8.19326 4.19241 8.19326 4.42996V8.08466L10.5817 9.89266C10.7718 10.0352 10.8102 10.3046 10.6677 10.4946C10.5252 10.6847 10.2558 10.7231 10.0658 10.5806Z" fill="#626262"/>
          </g>
          <defs>
            <clipPath id="clip0_16354_1273">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>${t} <i style="vertical-align:middle;margin-left:12px;border-radius: 50%;display: inline-block;${window.innerWidth < 767 ? 'width:24px;height:24px;' : 'width:28px;height:28px;'}background:${c};${c == "#fff" || c == "#ffffff" ? `border: 1px solid #ddd;`:``}"></i>
        <div class="remove-recent-search" data-value="${item.value}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" >
            <path d="M13.6594 2.34065C10.5379 -0.780218 5.46155 -0.780218 2.34009 2.34065C-0.78003 5.46153 -0.78003 10.5393 2.34009 13.6602C3.90082 15.2203 5.95044 16 8.00009 16C10.0497 16 12.0987 15.2203 13.6594 13.6602C16.7802 10.5394 16.7802 5.46153 13.6594 2.34065ZM11.3009 10.3586C11.5617 10.6194 11.5617 11.0409 11.3009 11.3017C11.1709 11.4318 11.0001 11.4971 10.8294 11.4971C10.6586 11.4971 10.4879 11.4318 10.3578 11.3017L8.00005 8.9432L5.64295 11.301C5.51223 11.4311 5.34146 11.4965 5.17138 11.4965C5.00065 11.4965 4.82988 11.4311 4.69982 11.301C4.43904 11.0402 4.43904 10.618 4.69982 10.3579L7.05693 8.00008L4.69916 5.64227C4.43838 5.38149 4.43838 4.95928 4.69916 4.69915C4.95929 4.43837 5.38148 4.43837 5.64226 4.69915L8.00002 7.05696L10.3578 4.69915C10.6186 4.43837 11.0401 4.43837 11.3009 4.69915C11.5617 4.95928 11.5617 5.38149 11.3009 5.64227L8.94312 8.00008L11.3009 10.3586Z" fill="#BDBDBD"/>
          </svg>
        </div>
        </li>`;
          break;
        case "url":
        case "img":
          lis += `<li tabindex='0' onclick='suggestionClick(this);' data-type="${item.type}" data-value="${item.value}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="history-icon-search">
          <g clip-path="url(#clip0_16354_1273)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 8C15.25 12 12 15.25 8 15.25C4.0125 15.25 0.75 12 0.75 8C0.75 7.7875 0.9125 7.625 1.125 7.625C1.3375 7.625 1.5 7.7875 1.5 8C1.5 11.5875 4.4125 14.5 8 14.5C11.5875 14.5 14.5 11.5875 14.5 8C14.5 4.4125 11.5875 1.5 8 1.5C6.2875 1.5 4.675 2.1625 3.4625 3.3625H4.3C4.5125 3.3625 4.675 3.525 4.675 3.7375C4.675 3.95 4.5125 4.1125 4.3 4.1125H2.5C2.2875 4.1125 2.125 3.95 2.125 3.7375V1.95C2.125 1.7375 2.2875 1.575 2.5 1.575C2.7125 1.575 2.875 1.7375 2.875 1.95V2.875L2.8875 2.8625C4.2375 1.5 6.0625 0.75 8 0.75C12 0.75 15.25 4 15.25 8ZM10.0658 10.5806L7.48597 8.64576C7.3931 8.57095 7.33333 8.44239 7.33333 8.29964V4.42996C7.33333 4.19241 7.52574 4 7.7633 4C8.00085 4 8.19326 4.19241 8.19326 4.42996V8.08466L10.5817 9.89266C10.7718 10.0352 10.8102 10.3046 10.6677 10.4946C10.5252 10.6847 10.2558 10.7231 10.0658 10.5806Z" fill="#626262"/>
          </g>
          <defs>
            <clipPath id="clip0_16354_1273">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>Similar to <img src="${item.value}" style="display: inline;vertical-align: middle;overflow: hidden;border-radius: 9999999px;${window.innerWidth < 767 ? 'width:24px;height:24px;' : 'width:28px;height:28px;'};margin-left:12px;border: 1px solid #ddd;object-fit: contain;" />
        <div class="remove-recent-search" data-value="${item.value}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M13.6594 2.34065C10.5379 -0.780218 5.46155 -0.780218 2.34009 2.34065C-0.78003 5.46153 -0.78003 10.5393 2.34009 13.6602C3.90082 15.2203 5.95044 16 8.00009 16C10.0497 16 12.0987 15.2203 13.6594 13.6602C16.7802 10.5394 16.7802 5.46153 13.6594 2.34065ZM11.3009 10.3586C11.5617 10.6194 11.5617 11.0409 11.3009 11.3017C11.1709 11.4318 11.0001 11.4971 10.8294 11.4971C10.6586 11.4971 10.4879 11.4318 10.3578 11.3017L8.00005 8.9432L5.64295 11.301C5.51223 11.4311 5.34146 11.4965 5.17138 11.4965C5.00065 11.4965 4.82988 11.4311 4.69982 11.301C4.43904 11.0402 4.43904 10.618 4.69982 10.3579L7.05693 8.00008L4.69916 5.64227C4.43838 5.38149 4.43838 4.95928 4.69916 4.69915C4.95929 4.43837 5.38148 4.43837 5.64226 4.69915L8.00002 7.05696L10.3578 4.69915C10.6186 4.43837 11.0401 4.43837 11.3009 4.69915C11.5617 4.95928 11.5617 5.38149 11.3009 5.64227L8.94312 8.00008L11.3009 10.3586Z" fill="#BDBDBD"/>
          </svg>
        </div>
        </li>`;
          break;
      }   
    });
    
    $("#searchSuggestionsUL").html(lis).show();
    $("#searchSuggestions").show();
    suggestlistItems = document.querySelectorAll(".searchSuggestionsUL li");
    searchcurrentLI = -1;

    if (window.innerWidth < 767) {
      $("#searchSuggestionsULMobile").html(lis).show();
      suggestlistItems = document.querySelectorAll(".searchSuggestionsULMobile li");
    }
  }
  else
  {
    $("#searchSuggestions").show();
    $("#searchPopParent").show();
    $(".searchSuggestTitle").hide();
    $("#searchSuggestionsUL").hide();
    $("#searchSuggestionsULMobile").hide();
    $(".gray-overlay").show();

    if (window.innerWidth < 767) {
      $('body').css('overflow', 'hidden');
      $("#mobileSearchPanel").show();

      setTimeout(function() {
        $("#qMobile[name='q']").get(0).focus();
      }, 0);
    }
  }

  setTimeout(function() {
    $('.remove-recent-search').click(function(e) {
      e.stopPropagation();
      const removeValue = $(this).data('value');
      $(this).parent().remove();
  
      let s = localStorage.getItem("recentSearches") == null ? "" : localStorage.getItem("recentSearches");
      if (s != "" && isJSON(s)) {
        let recentSearchArr = JSON.parse(s);
        recentSearchArr = recentSearchArr.filter(function(obj) {
          return obj.value !== removeValue;
        });

        localStorage.setItem("recentSearches", JSON.stringify(recentSearchArr));
      }
  })}, 500)
}

function setLocalStorageRecentSearch(v, type) {
  //del is the value that returned 0 results if they select an alternate option
  let s = localStorage.getItem("recentSearches") == null ? "" : localStorage.getItem("recentSearches");
  let storeArray = [];
  if (s != "" && isJSON(s)) 
  {
    storeArray=JSON.parse(s);  
    let foundit = false;
    let pos = 0;
    for (let av=0;av<storeArray.length;av++)
    {
      if (storeArray[av].value == v)
      {
        foundit=true;
        pos = av;
        break;
      }
    }
    if (foundit)
    {
      let x = storeArray.splice(pos, 1); 
    }
    else if (storeArray.length > 6)
    {
       let xx = storeArray.splice(0, 1); 
    }
  }
  let nv = {"value":v,"type":type};  
  storeArray.push(nv);
  localStorage.setItem("recentSearches", JSON.stringify(storeArray));
}

function suggestionClick(e, del) {
  let type = "term";
  if ($(e).data("type"))
  {
    type = $(e).data("type");
  }
  $("#searchPopParent").hide();
  $(".gray-overlay").hide();
  $(".close-search").hide();
  $(".close-search-mobile").hide();
  $(".search-mag-icon").show();
  let dym = "";
  if (del) {
    let url = new URL(window.location);
    setLocalStorageRecentSearch($(e).data("value"),type);
    dym="&dym=1";
  }
  else {
    setLocalStorageRecentSearch($(e).data("value"),type);
  }
  if (false && location.href.indexOf("/luxe") > -1 && location.href.indexOf("account/register") == -1) {
    location.href = "/pages/luxe-search-results-page?q=" + $(e).html().replace("&amp;","%26") + "&page=1" + dym;
  }
  else {
    switch(type)
    {
      case "term":
        location.href = "/pages/search-results-page?q=" + $(e).data("value").replace("&amp;","%26") + "&page=1" + dym;
        break;
      case "img":
        imgsearchimg($(e).data("value"));
        break;
      case "url":
        imgsearchurl($(e).data("value"));
        break;
      case "clr":
        if ($(e).data("value").indexOf("#") == -1)
        {
          location.href = `/pages/search-results-page?clr=1&color=${$(e).data("value")}`;
        }
        else
        {
          searchByColor($(e).data("value"));
        }        
        break;
    }    
  }
}
function searchByColor(hex)
{
  setLocalStorageRecentSearch(hex,"clr");
  location.href = `/pages/search-results-page?clr=1&ColorHex=${hex.replace("#","%23")}`;
}
function funcDataLayer(products, totalCount, term) {
  //$('meta[property=og\\:image]').attr('content', 'http://myweb.com/image.jpg');
  window.dataLayerData.collection.products = [];
  window.dataLayerData.collection.productCount = totalCount.toString();
  window.dataLayerData.collection.searchTerm = term;
  for (let x = 0; x < products.length; x++) {
    window.dataLayerData.collection.products.push(
      {
        'id': products[x].id,
        'title': products[x].title.replace(/'/g, ""),
        'price': products[x].price,
        'msrp': products[x].msrp,
        'type': products[x].type,
        'vendor': products[x].vendor,
        'designer': products[x].brand,
        'inStock': true,
        'variantID': products[x].variantID
      });
  }
  window.mAds();
}
function getParentNodes(handle,data)
{
  let result = [];
  let history = [];
  const traverse = function(node)
  {
    if (node.handle === handle)
    {
      result.push(node.title);
    }
    else
    {
      if (node.children && node.children.length > 0)
      {
        node.children.forEach(function(child)
        {
          if (!history.includes(child.handle) && child.handle != "home-dining-kitchen-serveware")
          {
            traverse(child);
          }
        });
      }
      if (!history.includes(node.handle) && node.handle != "home-dining-kitchen-serveware")
      {
        result.push(node);
        history.push(node.handle);
      }
    }
    history.push(node.handle);
  };

  data.forEach(function(node) {
    if (!history.includes(node.handle))
      traverse(node);
  });

  return result.reverse();
}

function fuzzySearch(q) {
  if (q==undefined)
    return;
  q=q.replace("+"," ");
  let s = q.trim().split(' ');
  //let termCount = s.length;
  //let autoCompleteMode = (termCount == 1) ? 'twoTerms' : 'oneTermWithContext';//i dont think this matters for the suggestions
  let autoCompleteMode = "";
  //let searchFields = (termCount > 2) ? 'Title' : 'Brand';
  let searchFields = "Brand";

  let ss = "";
  let arr = [];
  $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${s[0]}`, function (data, status) {
    if (data.value.length > 0)
    {
      for (let x = 0; x < data.value.length; x++) {
        if (!arr.includes(data.value[x]["@search.text"]))
          arr.push(data.value[x]["@search.text"])
      }
    }
    searchFields = "BrandCategory";
    $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${s[0]}`, function (data, status) {
      if (data.value.length > 0)
      {
        for (let x = 0; x < data.value.length; x++) {
          if (!arr.includes(data.value[x]["@search.text"]))
            arr.push(data.value[x]["@search.text"])
        }
      }
      searchFields = "Category/Title";
      $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${s[0]}`, function (data, status) {
        if (data.value.length > 0)
        {
          for (let x = 0; x < data.value.length; x++) {
            if (!arr.includes(data.value[x]["@search.text"]))
              arr.push(data.value[x]["@search.text"])
          }
        }
        searchFields = "Brand,BrandCategory,Category/Title";
        $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${q.trim()}`, function (data, status) {
          if (data.value.length > 0)
          {
            for (let x = 0; x < data.value.length; x++) {
              if (!arr.includes(data.value[x]["@search.text"]))
                arr.push(data.value[x]["@search.text"])
            }
          }
          if (s.length > 1)
          {
            searchFields = "Brand";
            $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${s[1]}`, function (data, status) {
              if (data.value.length > 0)
              {
                for (let x = 0; x < data.value.length; x++) {
                  if (!arr.includes(data.value[x]["@search.text"]))
                    arr.push(data.value[x]["@search.text"])
                }
              }
              searchFields = "BrandCategory";
              $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${s[1]}`, function (data, status) {
                if (data.value.length > 0)
                {
                  for (let x = 0; x < data.value.length; x++) {
                    if (!arr.includes(data.value[x]["@search.text"]))
                      arr.push(data.value[x]["@search.text"])
                  }
                }
                searchFields = "Category/Title";
                $.get(`https://srch-spo.search.windows.net/indexes/${theme.settings.searchIndex}/docs/suggest?api-version=2020-06-30&api-key=6B5A747768D00805C38E2F6520AE5351&searchmode=any&suggesterName=ag&autocompleteMode=${autoCompleteMode}&queryType=simple&fuzzy=true&searchFields=${searchFields}&search=${s[1]}`, function (data, status) {
                  if (data.value.length > 0)
                  {
                    for (let x = 0; x < data.value.length; x++) {
                      if (!arr.includes(data.value[x]["@search.text"]))
                        arr.push(data.value[x]["@search.text"])
                    }
                  }
                  for (let x = 0; x < 4; x++) {
                    if (arr[x]) {
                      ss += `<div onclick='suggestionClick(this,true);' class='suggestion' data-value="${arr[x]}">${arr[x]}</div>`;
                    }
                  }
                  if (ss != "")
                  {
                    $(".noResults").append("<div class='noResultsSuggestions'>Did you mean..." + ss +"</div>");
                  }
                });
              });
            });
          }
          else
          {
            $(".noResults").append("<div class='noResultsNoSuggestions'>Check the spelling, try a more general term or look up a specific <a href='https://shoppremiumoutlets.com/pages/brands?cid=ZSR:SPL:Brands'>brand or designer</a>.</div>");
           	for (let x = 0; x < 4; x++) {
              if (arr[x]) {
                ss += `<div onclick='suggestionClick(this,true);' class='suggestion' data-value="${arr[x]}">${arr[x]}</div>`;
              }
            }
            if (ss != "")
            {
              $(".noResults").append("<div class='noResultsSuggestions'>Did you mean..." + ss +"</div>");
            }
          }
        });
      });
    });
  });
}

function doPaging(current, { range, pages, start = 1 }) {
  let paging = [];
  if (range > pages)
    range = pages;
  var i = Math.min(pages + start - range, Math.max(start, current - (range / 2 | 0)));
  let end = i + range;
  let url = new URL(window.location);

  while (i < end) { url.searchParams.set("page",i); paging.push(i === current ? `<li><span class="pagerCurrentPage">${i}</span></li>` : `<li><a data-pagenum="${i}" class="pagefilter" href="${url}">${i}</a></li>`); i++; }
  return paging;
}
async function addClick() {
  $(".collapsible-trigger").click(function () {
    if ($(this).data("key") != undefined && !$(this).hasClass("is-open") && $(this).data("key").indexOf("Size") > -1 && $(this).data("key") != "WomensSpecialSizeType" && $(this).data("key") != "CaratSize") {
      sort("#filter" + $(this).data("key"));
    }
    if (!$(this).data("no-scroll")) { // Added to prevent section azure search side filter from scrolling on accordion click
      var t = $(this)[0];
      setTimeout(function () {
        t.scrollIntoView();
      }, 500);
    }
  });
}

async function checkSomeStuff() {
  await setTimeout(function() {
      let url = new URL(window.location);
      url.searchParams.forEach(function (value, key) {
        let vals = url.searchParams.get(key).replace(/\&/g, "").replace(/%252B/g, "").replace(/%2B/g, "").replace(/%20/g, "").replace(/\s/g, "").replace(/\'/g, "").replace(/%27/g, "").replace(/%2520/g, "").replace(/%2527/g, "").replace(/%26/g, "").split(",");
        $('[data-filter-type="' + key + '"]').each(function () {
          if (key == "color") {
            if (vals.includes($(this).data("value"))) {
              $(this).addClass("color-active");
            }
            else {
              $(this).removeClass("color-active");
            }
          }
          else {
            //.replace(/%20/g," ").replace(/%26/g,"&")
            if (vals.includes($(this).val().replace(/\&/g, "").replace(/%252B/g, "").replace(/%252B/g, "").replace(/%2B/g, "").replace(/%20/g, "").replace(/\s/g, "").replace(/\'/g, "").replace(/%27/g, "").replace(/%2520/g, "").replace(/%2527/g, "").replace(/%26/g, ""))) {
              $(this).prop("checked", true);
            }
            else {
              $(this).prop("checked", false);
            }
          }
        });
      });
    });
}
function mobileFilterClose() {
  $("body").removeClass("no-scroll");
  $("#side-bar").hide();
}
function mobileFilterShow() {
  $("body").addClass("no-scroll");
  $("#side-bar").show();
}
function crumbRoot(cat) {
  location.href = window.location.pathname + "?" + cat;
}
function clearFacet(key, val) {
  let url = new URL(window.location);
  let v = url.searchParams.get(key);
  let arr = v.split(",");
  for (var i = 0; i < arr.length; i++) { if (arr[i] === val.replace("%27", "'")) { arr.splice(i, 1); } }
  let join = arr.join(",");
  if (join.length > 0) {
    url.searchParams.set(key, arr.join(","));
  }
  else {
    url.searchParams.delete(key);
  }
  url.searchParams.set("page", 1);
  $("#filter" + key).each(function () {
    if ($(this).val() == val)
      $(this).prop("checked", false);
  });
  window.history.pushState({}, '', url.href.replace("%2527", "%27"));
  window.fetchPage(1, true);
  let s = "filter:" + key.toLowerCase() + ":remove";
  //console.log(s);
  //_satellite.track("Facet_Click", { "action":s });
}
function allSearchResults() {
  //let url = new URL(window.location);
  //let search = url.searchParams.has("q") ? url.searchParams.get("q") : "";
  //url = new URL("https://" + window.location.hostname + window.location.pathname);
  //if (search != "")
  //url.searchParams.set("q",search);
  let url = new URL(window.location.href);
  url.searchParams.delete("RootCategory");
  window.history.pushState({}, '', url.href.replace("%2527", "%27"));
  window.fetchPage(1, true);
}
function clearAllFacets() {
  let url = new URL(window.location);
  let rooTCat = url.searchParams.has("RootCategory") ? url.searchParams.get("RootCategory") : "";
  let productTypeRoot = url.searchParams.has("ProductTypeRoot") ? url.searchParams.get("ProductTypeRoot") : "";
  let productType = url.searchParams.has("ProductType") ? url.searchParams.get("ProductType") : "";
  let search = url.searchParams.has("q") ? url.searchParams.get("q") : "";
  let img = url.searchParams.has("img") ? url.searchParams.get("img") : "";
  url = new URL("https://" + window.location.hostname + window.location.pathname);
  if (rooTCat != "")
    url.searchParams.set("RootCategory", rooTCat);
  if (productTypeRoot != "")
    url.searchParams.set("ProductTypeRoot", productTypeRoot);
  if (productType != "")
    url.searchParams.set("ProductType", productType);
  if (search != "")
    url.searchParams.set("q", search);
  if (img != "")
    url.searchParams.set("img", "1");
  url.searchParams.set("page", 1);
  window.history.pushState({}, '', url.href.replace("%2527", "%27"));
  window.fetchPage(1, true);
  let s = "filter:facets:remove";
  //console.log(s);
  //_satellite.track("Facet_Click", { "action":s });
}
function pageClick(page) {
  let url = new URL(window.location);
  if (page == url.searchParams.get('page'))
    return;
  url.searchParams.set('page', page);
  window.history.pushState({}, '', url.href.replace("%2527", "%27"));
  window.fetchPage(page, false);
  let s = "filter:pagination:click";
  //_satellite.track("Facet_Click", { "action":s });
}
window.currentActiveFilteClass = "";
function filterClick(cPage, facets) {
  $(".product-filters-checkbox-2").off("click").click(function ()
  {
    let url = new URL(window.location);
    let t = $(this).data("filter-type");
    let v = $(this).val();
    let search = "";
    let imgsearch = false;
    let orderBy = "";
    let discountoff = "";
    if (url.searchParams.has("q"))
      search = url.searchParams.get("q");
    if (url.searchParams.has("orderby"))
      orderBy = url.searchParams.get("orderby");
    if (url.searchParams.has("Discount"))
      discountoff = url.searchParams.get("Discount");
    if (url.searchParams.has("img"))
      imgsearch = true;
    if (t == "color"){
      url.searchParams.delete("ColorHex");
      url.searchParams.delete("clr");
      v = $(this).data("value");
    }

    if (t == "ProductType" || t == "root" || t == "newroot") {
      $("span").removeClass("activeType");
      $("span").removeClass("activeRootType");
    }
    let vReplaced = v.replace(/&/g, "%26").replace(/\s/g, "%20");
    let isChecked = $(this).is(":checked");
    let searchParams = url.searchParams;
    if (t == "newroot")
    {
      $('[value="'+ $(this).val() +'"]').parent().find("span").addClass('activeType');
      document.title = $('[value="'+ $(this).val() +'"]').parent().find("a").html().replace(/&amp;/g,"&") + " | ShopSimon";
      let turl = "/collections/" + v;
      if (search != "" || imgsearch)
        turl = "/pages/search-results-page";
      if (searchParams){
        turl += "?" + searchParams;
      }
      let url = new URL("https://" + window.location.hostname + turl);

      url.searchParams.delete("ProductType");
      url.searchParams.delete("ProductTypeRoot");
      if (search != "")
        url.searchParams.set("q", search);
      if (orderBy != "")
        url.searchParams.set("orderby", orderBy);
      if (discountoff != "")
        url.searchParams.set("Discount", discountoff);
      url.searchParams.set("page", "1");
      window.history.pushState({}, '', url.href.replace("%2527", "%27"));
      window.fetchPage(1, true, v);
      window.oldlist = null;
    }
    else if (t == "ProductType") {
      //let url = new URL("https://" + window.location.hostname + window.location.pathname);
      let url = new URL(window.location.href);
      url.searchParams.set("ProductType", vReplaced);
      url.searchParams.set("page", "1");
      if (search != "")
        url.searchParams.set("q", search);
      if (orderBy != "")
        url.searchParams.set("orderby", orderBy);
      if (discountoff != "")
        url.searchParams.set("Discount", discountoff);
      window.history.pushState({}, '', url.href.replace("%2527", "%27"));
      window.fetchPage(1, true);
      document.title = $('[value="'+ $(this).val() +'"]').parent().find("a").html().replace(/&amp;/g,"&") + " | ShopSimon";
    }
    else if (t != "ProductType" && url.searchParams.has(t)) {
      let p = url.searchParams.get(t).replace("''", "%27");

      if (p.replace(/\&/g, "").replace(/%26%20/g, "").replace(/%252B/g, "").replace(/%2B/g, "").replace(/%20/g, "").replace(/\s/g, "").replace(/\'/g, "").replace(/%27/g, "").replace(/%2520/g, "").replace(/%2527/g, "").replace("%26", "") == v.replace(/\&/g, "").replace("''", "%27").replace(/%26%20/g, "").replace(/%252B/g, "").replace(/%2B/g, "").replace(/%20/g, "").replace(/\s/g, "").replace(/\'/g, "").replace(/%27/g, "").replace(/%2520/g, "").replace(/%2527/g, "").replace("%26", "")) {

        if (!isChecked) {
          url.searchParams.delete(t);
          //setCookie(t, "", -1);
        }
        else {
          let v = url.searchParams.get(t);
          url.searchParams.set(t, vReplaced);
        }
      }
      else if (p.indexOf(vReplaced + ",") > -1) {
        if (!isChecked) {
          vReplaced = p.replace(vReplaced + ",", "");
          url.searchParams.set(t, vReplaced);
        }
        else {
          url.searchParams.set(t, vReplaced);
        }
      }
      else if (p.indexOf("," + vReplaced) > -1) {
        if (!isChecked) {
          vReplaced = p.replace("," + vReplaced, "");
          url.searchParams.set(t, vReplaced);
        }
        else {
          url.searchParams.set(t, vReplaced);
        }
      }
      else {
        vReplaced += "," + p;
        url.searchParams.set(t, vReplaced);
      }
      //if (isChecked && t.indexOf("Size") > -1) {
        //setCookie(t, vReplaced, 1);
      //}
      //to keep the flyout of the facet being filtered
      window.oldlist = { "id": t, "val": $("#collapsible-key-" + t).html() };
      if (search != "")
        url.searchParams.set("q", search);
      if (orderBy != "")
        url.searchParams.set("orderby", orderBy);
      if (discountoff != "")
        url.searchParams.set("Discount", discountoff);
      url.searchParams.set('page', 1);
      window.history.pushState({}, '', url.href.replace("%2527", "%27%27"));
      window.fetchPage(1, true);
    }
    else {
      //to keep the flyout of the facet being filtered
      window.oldlist = { "id": t, "val": $("#collapsible-key-" + t).html() };
      if (search != "")
        url.searchParams.set("q", search);
      url.searchParams.set(t, vReplaced);

     // if (t.indexOf("Size") > -1) {
        //setCookie(t, vReplaced, 1);
      //}

      url.searchParams.set('page', 1);
      window.history.pushState({}, '', url.href.replace("%2527", "%27").replace("%2520%2526%2520", "%20%26%20").replace("%2520%25252B%2520", "%20%252B%20").replace("%27%27%2527", "%27"));
      window.fetchPage(1, true);
    }

    if (t == "color") {
      $(this).toggleClass("color-active");
    }
    url = new URL(window.location);

    let m = isChecked ? "add" : "remove";
    if (t.toLowerCase() == "producttype")
      m = "click";
    let s = "filter:" + t.toLowerCase() + ":" + m;
    //console.log(s);
    //_satellite.track("Facet_Click", { "action":s });
  });
}

function getHexForColor(color) {
  switch (color) {
    case "beige":
      return "#F2E4C5";
    case "black":
      return "#111111";
    case "blue":
      return "#64B4F6";
    case "brown":
      return "#795548";
    case "gold":
      return "linear-Gradient(224deg, rgba(221, 184, 29, 1), rgba(255, 255, 255, 1), rgba(221, 184, 29, 1)) !important;";
    case "grey":
      return "#AAAAAA";
    case "green":
      return "#81C784";
    case "silver":
      return "linear-Gradient(224deg, rgb(193, 193, 193), rgb(243, 243, 243) 52%, rgb(195, 195, 195)) !important;";
    case "multi":
      return "linear-gradient(70deg, #95D952 20.56%, rgba(222, 235, 79, 0.79) 41.15%, rgba(220, 158, 81, 0.82) 64.23%, rgba(217, 82, 82, 0.85) 83.72%);";
    case "clear":
      return "";
    case "orange":
      return "#FFA500";
    case "pink":
      return "#FFC0CB";
    case "purple":
      return "#7E56C2";
    case "red":
      return "#E02724";
    case "white":
      return "#fff";
    case "yellow":
      return "#FFF176";
    default:
      return "";
  }
}
function adBackroundLoad()
{
  $(".madimg").each(function( index ) {
    let u = $(this).data("background-image-url");
    $(this).css("background-image","url('" + u + "')");
    $(this).addClass("loaded");
  });
}
function BackgroundNode({ node, loadedClassName }) {
  let src = node.getAttribute('data-background-image-url');
  let show = (onComplete) => {
    requestAnimationFrame(() => {
      node.style.backgroundImage = "url(" + src + ")"
      node.classList.add(loadedClassName);
      onComplete();
    })
  }

  return {
    node,

    // onComplete is called after the image is done loading.
    load: (onComplete) => {
      let img = new Image();
      img.onload = show(onComplete);
      img.src = src;
    }
  }
}

function BackgroundLazyLoader({ selector, loadedClassName } = { selector: '[data-background-image-url]', loadedClassName: 'loaded' }) {
  let nodes = [].slice.apply(document.querySelectorAll(selector))
    .map(node => new BackgroundNode({ node, loadedClassName }));

  let callback = (entries, observer) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) {
        return;
      }

      let obj = nodes.find(it => it.node.isSameNode(target));

      if (obj) {
        obj.load(() => {
          // Unobserve the node:
          observer.unobserve(target);
          // Remove this node from our list:
          nodes = nodes.filter(n => !n.node.isSameNode(target));

          // If there are no remaining unloaded nodes,
          // disconnect the observer since we don't need it anymore.
          if (!nodes.length) {
            observer.disconnect();
          }
        });
      }
    })
  };

  let observer = new IntersectionObserver(callback);
  nodes.forEach(node => observer.observe(node.node));
};
var brandSearchTimer2;
function brandSearchFunc2(el, ee) {
  clearTimeout(brandSearchTimer2);
  let el2 = el.value.replace(/'/g, "%27").replace(/&/g, "%26").replace(/\s/g, "%20").replace(/\+/g, "%2B").toUpperCase();
  brandSearchTimer2 = setTimeout(function () {
    $(ee).find("li").each(function () {
      let h = $(this).find("label input");
      if (h != undefined && h[0] != undefined) {
        if (h[0].value.toUpperCase().indexOf(el2) > -1) {
          $(this).show();
        }
        else {
          $(this).hide();
        }
      }
    });
  }, 1000);
}

const closeMobileSearch = () => {
  $('#mobileSearchPanel').hide();
  $("#shoppingAssistantSuggest").hide();
  $("#imageSearchSuggest").hide();
  $("#colorPickSuggest").hide();
  $("#searchPopParent").hide();
  $(".gray-overlay").hide();
  $(".close-search").hide();
  $(".close-search-mobile").hide();
  $(".search-mag-icon").show();
  $('body').css('overflow', 'auto');
  $("#qDesktop[name='q']").prop('disabled', false);
}

function sort(id) 
{  
  let el = $(id);
  let $children = $(el).children('li');
  $children.sort(function (a, b) {
    let a2 = a.dataset.value;    
    let b2 = b.dataset.value;
    if (a2 == "0-50")
    {
      a2 = "01";
    }
    else if (a2 == "50-100")
    {
      a2 = "02";
    }
    else if (a2 == "100-200")
    {
      a2 = "03";
    }
    else if (a2 == "200-300")
    {
      a2 = "04";
    }
    else if (a2 == "300-400")
    {
      a2 = "05";
    }
    else if (a2 == "400-500")
    {
      a2 = "06";
    }
    else if (a2 == "500-1000")
    {
      a2 = "07";
    }
    else if (a2 == "1000-10000")
    {
      a2 = "08";
    }
    else if (a2 == "1" || a2 == "1.5" || a2 == "2" || a2 == "2.5" || a2 == "3" || a2 == "3.5" || a2 == "4" || a2 == "4.5" || a2 == "5" || a2 == "5.5" || a2 == "6" || a2 == "6.5" || a2 == "7" || a2 == "7.5" || a2 == "8" || a2 == "8.5" || a2 == "9" || a2 == "9.5") {
      a2 = "0" + a2;
    }
    else if (a2 == "US%200%20Baby") {
      a2 = "01";
    }
    else if (a2 == "US%201%20Baby") {
      a2 = "02";
    }
    else if (a2 == "US%201.5%20Baby") {
      a2 = "022";
    }
    else if (a2 == "US%202%20Baby") {
      a2 = "03";
    }
    else if (a2 == "US%203%20Baby") {
      a2 = "04";
    }
    else if (a2 == "US%202.0%20Toddler") {
      a2 = "05";
    }
    else if (a2 == "US%202.5%20Toddler") {
      a2 = "06";
    }
    else if (a2 == "US%203.0%20Toddler") {
      a2 = "07";
    }
    else if (a2 == "US%203.5%20Toddler") {
      a2 = "08";
    }
    else if (a2 == "US%204%20Toddler") {
      a2 = "09";
    }
    else if (a2 == "US%204.5%20Toddler") {
      a2 = "10";
    }
    else if (a2 == "US%205%20Toddler") {
      a2 = "11";
    }
    else if (a2 == "US%205.5%20Toddler") {
      a2 = "12";
    }
    else if (a2 == "US%206%20Toddler") {
      a2 = "13";
    }
    else if (a2 == "US%206.5%20Toddler") {
      a2 = "14";
    }
    else if (a2 == "US%207%20Toddler") {
      a2 = "15";
    }
    else if (a2 == "US%207.5%20Toddler") {
      a2 = "16";
    }
    else if (a2 == "US%208%20Toddler") {
      a2 = "17";
    }
    else if (a2 == "US%208.5%20Toddler") {
      a2 = "18";
    }
    else if (a2 == "US%209%20Toddler") {
      a2 = "19";
    }
    else if (a2 == "US%209.5%20Toddler") {
      a2 = "20";
    }
    else if (a2 == "US%2010%20Toddler") {
      a2 = "21";
    }
    else if (a2 == "US%201%20Little%20Kid") {
      a2 = "22a";
    }
    else if (a2 == "US%201.5%20Little%20Kid" || a2 == "US%201.5%20Little%20Lid") {
      a2 = "22b";
    }
    else if (a2 == "US%202%20Little%20Kid") {
      a2 = "23a";
    }
    else if (a2 == "US%202.5%20Little%20Kid") {
      a2 = "23b";
    }
    else if (a2 == "US%203%20Little%20Kid") {
      a2 = "24";
    }
    else if (a2 == "US%204%20Little%20Kid") {
      a2 = "25";
    }
    else if (a2 == "US%205%20Little%20Kid") {
      a2 = "26";
    }    
    else if (a2 == "US%206%20Little%20Kid") {
      a2 = "27";
    }
    else if (a2 == "US%207%20Little%20Kid") {
      a2 = "28";
    }
    else if (a2 == "US%208%20Little%20Kid") {
      a2 = "29";
    }
    else if (a2 == "US%209%20Little%20Kid") {
      a2 = "30a";
    }
    else if (a2 == "US%209.5%20Little%20Kid") {
      a2 = "30b";
    }
    else if (a2 == "US%2010%20Little%20Kid") {
      a2 = "31a";
    }
    else if (a2 == "US%2010.5%20Little%20Kid") {
      a2 = "31b";
    }
    else if (a2 == "US%2011%20Little%20Kid") {
      a2 = "32a";
    }
    else if (a2 == "US%2011.5%20Little%20Kid") {
      a2 = "32b";
    }
    else if (a2 == "US%2012%20Little%20Kid") {
      a2 = "33a";
    }
    else if (a2 == "US%2012.5%20Little%20Kid") {
      a2 = "33b";
    }
    else if (a2 == "US%2013%20Little%20Kid") {
      a2 = "34a";
    }
    else if (a2 == "US%2013.5%20Little%20Kid") {
      a2 = "34b";
    }
    else if (a2 == "US%203.5%20Big%20Kid") {
      a2 = "35";
    }
    else if (a2 == "US%204%20Big%20Kid") {
      a2 = "36";
    }
    else if (a2 == "US%204.5%20Big%20Kid") {
      a2 = "37";
    }
    else if (a2 == "US%205%20Big%20Kid") {
      a2 = "38";
    }
    else if (a2 == "US%205.5%20Big%20Kid") {
      a2 = "39";
    }
    else if (a2 == "US%206%20Big%20Kid") {
      a2 = "40";
    }
    else if (a2 == "US%206.5%20Big%20Kid") {
      a2 = "41";
    }
    else if (a2 == "US%207%20Big%20Kid") {
      a2 = "42";
    }
    else if (a2 == "US%207.5%20Big%20Kid") {
      a2 = "43";
    }
    else if (a2 == "Newborn") {
      a2 = "0000";
    }
    else if (a2 == "0-3%20Months") {
      a2 = "0001";
    }
    else if (a2 == "3-6%20Months") {
      a2 = "0002";
    }
    else if (a2 == "6-9%20Months") {
      a2 = "0003";
    }
    else if (a2 == "9-12%20Months") {
      a2 = "0004";
    }
    else if (a2 == "12-18%20Months") {
      a2 = "0005";
    }
    else if (a2 == "18-24%20Months") {
      a2 = "0006";
    }
    else if (a2 == "US%201T") {
      a2 = "US%20001";
    }
    else if (a2 == "US%202T") {
      a2 = "US%20002";
    }
    else if (a2 == "US%203T") {
      a2 = "US%20003";
    }
    else if (a2 == "US%204T") {
      a2 = "US%20004";
    }
    else if (a2 == "US%205T") {
      a2 = "US%20005";
    }
    else if (a2 == "US%206T") {
      a2 = "US%20006";
    }
    else if (a2.startsWith("US%2000%20")) {
      a2 = "US%200000";
    }
    else if (a2.startsWith("US%200%20")) {
      a2 = "US%200001";
    }
    else if (a2.startsWith("US%201%20") || a2 == "US%201") {
      a2 = "US%2001";
    }
    else if (a2.startsWith("US%201.5%20") || a2 == "US%201.5") {
      a2 = "US%2001.5";
    }
    else if (a2.startsWith("US%202%20") || a2 == "US%202") {
      a2 = "US%2002";
    }
    else if (a2.startsWith("US%202.5%20") || a2 == "US%202.5") {
      a2 = "US%2002.5";
    }
    else if (a2.startsWith("US%203%20") || a2 == "US%203") {
      a2 = "US%2003";
    }
    else if (a2.startsWith("US%203.5%20") || a2 == "US%203.5") {
      a2 = "US%2003.5";
    }
    else if (a2.startsWith("US%204%20") || a2 == "US%204") {
      a2 = "US%2004";
    }
    else if (a2.startsWith("US%204.5%20") || a2 == "US%204.5") {
      a2 = "US%2004.5";
    }
    else if (a2.startsWith("US%205%20") || a2 == "US%205") {
      a2 = "US%2005";
    }
    else if (a2.startsWith("US%205.5%20") || a2 == "US%205.5") {
      a2 = "US%2005.5";
    }
    else if (a2.startsWith("US%206%20") || a2 == "US%206") {
      a2 = "US%2006";
    }
    else if (a2.startsWith("US%206.5%20") || a2 == "US%206.5") {
      a2 = "US%2006.5";
    }
    else if (a2.startsWith("US%207%20") || a2 == "US%207") {
      a2 = "US%2007";
    }
    else if (a2.startsWith("US%207.5%20") || a2 == "US%207.5") {
      a2 = "US%2007.5";
    }
    else if (a2.startsWith("US%208%20") || a2 == "US%208") {
      a2 = "US%2008";
    }
    else if (a2.startsWith("US%208.5%20") || a2 == "US%208.5") {
      a2 = "US%2008.5";
    }
    else if (a2.startsWith("US%209%20") || a2 == "US%209") {
      a2 = "US%2009";
    }
    else if (a2.startsWith("US%209.5%20") || a2 == "US%209.5") {
      a2 = "US%2009.5";
    }
    else if (a2.startsWith("UK%2000%20")) {
      a2 = "UT%200";
    }
    else if (a2.startsWith("UK%200%20")) {
      a2 = "UT%2000";
    }
    else if (a2.startsWith("UK%201%20") || a2 == "UK%201") {
      a2 = "UT%2001";
    }
    else if (a2.startsWith("UK%201.5%20") || a2 == "UK%201.5") {
      a2 = "UT%2001.5";
    }
    else if (a2.startsWith("UK%202%20") || a2 == "UK%202") {
      a2 = "UT%2002";
    }
    else if (a2.startsWith("UK%202.5%20") || a2 == "UK%202.5") {
      a2 = "UT%2002.5";
    }
    else if (a2.startsWith("UK%203%20") || a2 == "UK%203") {
      a2 = "UT%2003";
    }
    else if (a2.startsWith("UK%203.5%20") || a2 == "UK%203.5") {
      a2 = "UT%2003.5";
    }
    else if (a2.startsWith("UK%204%20") || a2 == "UK%204") {
      a2 = "UT%2004";
    }
    else if (a2.startsWith("UK%204.5%20") || a2 == "UK%204.5") {
      a2 = "UT%2004.5";
    }
    else if (a2.startsWith("UK%205%20") || a2 == "UK%205") {
      a2 = "UT%2005";
    }
    else if (a2.startsWith("UK%205.5%20") || a2 == "UK%205.5") {
      a2 = "UT%2005.5";
    }
    else if (a2.startsWith("UK%206%20") || a2 == "UK%206") {
      a2 = "UT%2006";
    }
    else if (a2.startsWith("UK%206.5%20") || a2 == "UK%206.5") {
      a2 = "UT%2006.5";
    }
    else if (a2.startsWith("UK%207%20") || a2 == "UK%207") {
      a2 = "UT%2007";
    }
    else if (a2.startsWith("UK%207.5%20") || a2 == "UK%207.5") {
      a2 = "UT%2007.5";
    }
    else if (a2.startsWith("UK%208%20") || a2 == "UK%208") {
      a2 = "UT%2008";
    }
    else if (a2.startsWith("UK%208.5%20") || a2 == "UK%208.5") {
      a2 = "UT%2008.5";
    }
    else if (a2.startsWith("UK%209%20") || a2 == "UK%209") {
      a2 = "UT%2009";
    }
    else if (a2.startsWith("UK%201")) {
      a2 = "UT%2010";
    }
    else if (a2.startsWith("UK%209.5%20") || a2 == "UK%209.5") {
      a2 = "UT%2009.5";
    }
    else if (a2.startsWith("UK%2032%20") || a2 == "UK%2032") {
      a2 = "UT%2010";
    }
    else if (a2.startsWith("EU%2016%20") || a2 == "EU%2016") {
      a2 = "UU%2016";
    }
    else if (a2.startsWith("EU%2017%20") || a2 == "EU%2017") {
      a2 = "UU%2017";
    }
    else if (a2.startsWith("EU%2018%20") || a2 == "EU%2018") {
      a2 = "UU%2018";
    }
    else if (a2.startsWith("EU%2019%20") || a2 == "EU%2019") {
      a2 = "UU%2019";
    }
    else if (a2.startsWith("EU%2020%20") || a2 == "EU%2020") {
      a2 = "UU%2020";
    }
    else if (a2.startsWith("EU%2021%20") || a2 == "EU%2021") {
      a2 = "UU%2021";
    }
    else if (a2.startsWith("EU%2022%20") || a2 == "EU%2022") {
      a2 = "UU%2022";
    }
    else if (a2.startsWith("EU%2023%20") || a2 == "EU%2023") {
      a2 = "UU%2023";
    }
    else if (a2.startsWith("EU%2024%20") || a2 == "EU%2024") {
      a2 = "UU%2024";
    }
    else if (a2.startsWith("EU%2025%20") || a2 == "EU%2025") {
      a2 = "UU%2025";
    }
    else if (a2.startsWith("EU%2026%20") || a2 == "EU%2026") {
      a2 = "UU%2026";
    }
    else if (a2.startsWith("EU%2027%20") || a2 == "EU%2027") {
      a2 = "UU%2027";
    }
    else if (a2.startsWith("EU%2028%20") || a2 == "EU%2028") {
      a2 = "UU%2028";
    }
    else if (a2.startsWith("EU%2029%20") || a2 == "EU%2029") {
      a2 = "UU%2029";
    }
    else if (a2.startsWith("EU%2030%20") || a2 == "EU%2030") {
      a2 = "UU%2030";
    }
    else if (a2.startsWith("EU%2031%20") || a2 == "EU%2031") {
      a2 = "UU%2031";
    }      
    else if (a2.startsWith("EU%2032%20") || a2 == "EU%2032") {
      a2 = "UU%2032";
    }
    else if (a2.startsWith("EU%2033%20") || a2 == "EU%2033") {
      a2 = "UU%2033";
    }
    else if (a2.startsWith("EU%2033.5%20") || a2 == "EU%2033.5") {
      a2 = "UU%2033.5";
    }
    else if (a2.startsWith("EU%2034%20") || a2 == "EU%2034") {
      a2 = "UU%2034";
    }
    else if (a2.startsWith("EU%2034.5%20") || a2 == "EU%2034.5") {
      a2 = "UU%2034.5";
    }
    else if (a2.startsWith("EU%2035") || a2 == "EU%2035") {
      a2 = "UU%2035";
    }
    else if (a2.startsWith("EU%2035.5") || a2 == "EU%2035.5") {
      a2 = "UU%2035.5";
    }
    else if (a2.startsWith("EU%2036") || a2 == "EU%2036") {
      a2 = "UU%2036";
    }
    else if (a2.startsWith("EU%2036%2F37") || a2 == "EU%2036%2F37") {
      a2 = "UU%2036.1";
    }
    else if (a2.startsWith("EU%2036.5") || a2 == "EU%2036.5") {
      a2 = "UU%2036.5";
    }
    else if (a2.startsWith("EU%2037") || a2 == "EU%2037") {
      a2 = "UU%2037";
    }
    else if (a2.startsWith("EU%2037%2F38") || a2 == "EU%2037%2F38") {
      a2 = "UU%2037.1";
    }
    else if (a2.startsWith("EU%2037.5") || a2 == "EU%2037.5") {
      a2 = "UU%2037.5";
    }
    else if (a2.startsWith("EU%2038") || a2 == "EU%2038") {
      a2 = "UU%2038";
    }
    else if (a2.startsWith("EU%2038.5%20") || a2 == "EU%2038.5") {
      a2 = "UU%2038.5";
    }
    else if (a2.startsWith("EU%2039") || a2 == "EU%2039") {
      a2 = "UU%2039";
    }
    else if (a2.startsWith("EU%2039.5%20") || a2 == "EU%2039.5") {
      a2 = "UU%2039.5";
    }
    else if (a2.startsWith("EU%2040") || a2 == "EU%2040") {
      a2 = "UU%2040";
    }
    else if (a2.startsWith("EU%2040.5%20") || a2 == "EU%2040.5") {
      a2 = "UU%2040.5";
    }
    else if (a2.startsWith("EU%2041") || a2 == "EU%2041") {
      a2 = "UU%2041";
    }
    else if (a2.startsWith("EU%2041.5%20") || a2 == "EU%2041.5") {
      a2 = "UU%2041.5";
    }
    else if (a2.startsWith("EU%2042") || a2 == "EU%2042") {
      a2 = "UU%2042";
    }
    else if (a2.startsWith("EU%2042.5%20") || a2 == "EU%2042.5") {
      a2 = "UU%2042.5";
    }
    else if (a2.startsWith("EU%2043") || a2 == "EU%2043") {
      a2 = "UU%2043";
    }
    else if (a2.startsWith("EU%2043.5%20") || a2 == "EU%2043.5") {
      a2 = "UU%2043.5";
    }
    else if (a2.startsWith("EU%2044") || a2 == "EU%2044") {
      a2 = "UU%2044";
    }
    else if (a2.startsWith("EU%2044.5%20") || a2 == "EU%2044.5") {
      a2 = "UU%2044.5";
    }
    else if (a2.startsWith("EU%2045") || a2 == "EU%2045") {
      a2 = "UU%2045";
    }
    else if (a2.startsWith("EU%2045.5%20") || a2 == "EU%2045.5") {
      a2 = "UU%2045.5";
    }
    else if (a2.startsWith("EU%2046") || a2 == "EU%2046") {
      a2 = "UU%2046";
    }
    else if (a2.startsWith("EU%2046.5%20") || a2 == "EU%2046.5") {
      a2 = "UU%2046.5";
    }
    else if (a2.startsWith("EU%2047") || a2 == "EU%2047") {
      a2 = "UU%2047";
    }
    else if (a2.startsWith("EU%2048") || a2 == "EU%2048") {
      a2 = "UU%2048";
    }
    else if (a2.startsWith("EU%2049") || a2 == "EU%2049") {
      a2 = "UU%2049";
    }
    else if (a2.startsWith("EU%2050") || a2 == "EU%2050") {
      a2 = "UU%2050";
    }
    else if (a2 == "One%20Size") {
      a2 = "x1898";
    }
    else if (b2 == "XXS") {
      a2 = "x1900";
    }
    else if (a2 == "XS") {
      a2 = "x1902";
    }
    else if (a2 == "S") {
      a2 = "x1904";
    }
    else if (a2 == "M") {
      a2 = "x1906";
    }
    else if (a2 == "L") {
      a2 = "x1908";
    }
    else if (a2 == "XL") {
      a2 = "x1910";
    }
    else if (a2 == "XXL") {
      a2 = "x1912";
    }
    else if (a2 == "XXXL") {
      a2 = "x1914";
    }
    else if (a2 == "XXXSmall") {
      a2 = "x1916";
    }
    else if (a2 == "XXSmall") {
      a2 = "x1918";
    }
    else if (a2 == "XSmall") {
      a2 = "x1920";
    }
    else if (a2 == "XSmall%2FSmall") {
      a2 = "x1921";
    }
    else if (a2 == "Small") {
      a2 = "x1922";
    }
    else if (a2 == "Small%2FMedium") {
      a2 = "x2012";
    }
    else if (a2 == "Medium") {
      a2 = "x2013";
    }
    else if (a2 == "Medium%2FLarge") {
      a2 = "x2014";
    }
    else if (a2 == "Large") {
      a2 = "x2015";
    }
    else if (a2 == "Large%2FXLarge") {
      a2 = "x2016";
    }
    else if (a2 == "XLarge") {
      a2 = "x2019";
    }
    else if (a2 == "XLarge%20Short") {
      a2 = "x2019";
    }
    else if (a2 == "XLarge%20Tall") {
      a2 = "x2020";
    }
    else if (a2 == "XXLarge") {
      a2 = "x2021";
    }
    else if (a2 == "XXLarge%20Tall") {
      a2 = "x2022";
    }
    else if (a2 == "XXXLarge") {
      a2 = "x2023";
    }
    else if (a2 == "XXXLarge%20Tall") {
      a2 = "x2024";
    }
    else if (a2 == "4XLarge") {
      a2 = "x2025";
    }
    else if (a2 == "4XLarge%20Tall") {
      a2 = "x2026";
    }
    else if (a2.startsWith("Plus")) {
      a2 = "x2028";
    }
    else if (a2 == "Petite%20XSmall") {
      a2 = "x2030";
    }
    else if (a2 == "Petite%20Small") {
      a2 = "x2032";
    }
    else if (a2 == "Petite%20Medium") {
      a2 = "x2034";
    }
    else if (a2 == "Petite%20Large") {
      a2 = "x2036";
    }
    else if (a2 == "Petite%20XLarge") {
      a2 = "x2037";
    }
    else if (a2 == "$50.00" || a2 == "$75.00" || a2 == "$100.00" || a2 == "$125.00" || a2 == "$150.00" || a2 == "$175.00" || a2 == "$200.00" || a2 == "$250.00" || a2 == "$300.00") {
      a2 = parseInt(a2.split('$')[1]);
    }      
    
    if (b2 == "0-50")
    {
      b2 = "01";
    }
    else if (b2 == "50-100")
    {
      b2 = "02";
    }
    else if (b2 == "100-200")
    {
      b2 = "03";
    }
    else if (b2 == "200-300")
    {
      b2 = "04";
    }
    else if (b2 == "300-400")
    {
      b2 = "05";
    }
    else if (b2 == "400-500")
    {
      b2 = "06";
    }
    else if (b2 == "500-1000")
    {
      b2 = "07";
    }
    else if (b2 == "1000-10000")
    {
      b2 = "08";
    }
    else if (b2 == "1" || b2 == "1.5" || b2 == "2" || b2 == "2.5" || b2 == "3" || b2 == "3.5" || b2 == "4" || b2 == "4.5" || b2 == "5" || b2 == "5.5" || b2 == "6" || b2 == "6.5" || b2 == "7" || b2 == "7.5" || b2 == "8" || b2 == "8.5" || b2 == "9" || b2 == "9.5") {
      b2 = "0" + b2;
    }
    else if (b2 == "US%200%20Baby") {      
      b2 = "01";
    }
    else if (b2 == "US%201%20Baby") {
      b2 = "02";
    }
    else if (b2 == "US%201.5%20Baby") {
      b2 = "022";
    }
    else if (b2 == "US%202%20Baby") {
      b2 = "03";
    }
    else if (b2 == "US%203%20Baby") {
      b2 = "04";
    }
    else if (b2 == "US%202.0%20Toddler") {
      b2 = "05";
    }
    else if (b2 == "US%202.5%20Toddler") {
      b2 = "06";
    }
    else if (b2 == "US%203.0%20Toddler") {
      b2 = "07";
    }
    else if (b2 == "US%203.5%20Toddler") {
      b2 = "08";
    }
    else if (b2 == "US%204%20Toddler") {
      b2 = "09";
    }
    else if (b2 == "US%204.5%20Toddler") {
      b2 = "10";
    }
    else if (b2 == "US%205%20Toddler") {
      b2 = "11";
    }
    else if (b2 == "US%205.5%20Toddler") {
      b2 = "12";
    }
    else if (b2 == "US%206%20Toddler") {
      b2 = "13";
    }
    else if (b2 == "US%206.5%20Toddler") {
      b2 = "14";
    }
    else if (b2 == "US%207%20Toddler") {
      b2 = "15";
    }
    else if (b2 == "US%207.5%20Toddler") {
      b2 = "16";
    }
    else if (b2 == "US%208%20Toddler") {
      b2 = "17";
    }
    else if (b2 == "US%208.5%20Toddler") {
      b2 = "18";
    }
    else if (b2 == "US%209%20Toddler") {
      b2 = "19";
    }
    else if (b2 == "US%209.5%20Toddler") {
      b2 = "20";
    }
    else if (b2 == "US%2010%20Toddler") {
      b2 = "21";
    }
    else if (b2 == "US%201%20Little%20Kid") {
      b2 = "22a";
    }
    else if (b2 == "US%201.5%20Little%20Kid" || b2 == "US%201.5%20Little%20Lid") {
      b2 = "22b";
    }
    else if (b2 == "US%202%20Little%20Kid") {
      b2 = "23a";
    }
    else if (b2 == "US%202.5%20Little%20Kid") {
      b2 = "23b";
    }
    else if (b2 == "US%203%20Little%20Kid") {
      b2 = "24";
    }
    else if (b2 == "US%204%20Little%20Kid") {
      b2 = "25";
    }
    else if (b2 == "US%205%20Little%20Kid") {
      b2 = "26";
    }    
    else if (b2 == "US%206%20Little%20Kid") {
      b2 = "27";
    }
    else if (b2 == "US%207%20Little%20Kid") {
      b2 = "28";
    }
    else if (b2 == "US%208%20Little%20Kid") {
      b2 = "29";
    }
    else if (b2 == "US%209%20Little%20Kid") {
      b2 = "30a";
    }
    else if (b2 == "US%209.5%20Little%20Kid") {
      b2 = "30b";
    }
    else if (b2 == "US%2010%20Little%20Kid") {
      b2 = "31a";
    }
    else if (b2 == "US%2010.5%20Little%20Kid") {
      b2 = "31b";
    }
    else if (b2 == "US%2011%20Little%20Kid") {
      b2 = "32a";
    }
    else if (b2 == "US%2011.5%20Little%20Kid") {
      b2 = "32b";
    }
    else if (b2 == "US%2012%20Little%20Kid") {
      b2 = "33a";
    }
    else if (b2 == "US%2012.5%20Little%20Kid") {
      b2 = "33b";
    }
    else if (b2 == "US%2013%20Little%20Kid") {
      b2 = "34a";
    }
    else if (b2 == "US%2013.5%20Little%20Kid") {
      b2 = "34b";
    }
    else if (b2 == "US%203.5%20Big%20Kid") {
      b2 = "35";
    }
    else if (b2 == "US%204%20Big%20Kid") {
      b2 = "36";
    }
    else if (b2 == "US%204.5%20Big%20Kid") {
      b2 = "37";
    }
    else if (b2 == "US%205%20Big%20Kid") {
      b2 = "38";
    }
    else if (b2 == "US%205.5%20Big%20Kid") {
      b2 = "39";
    }
    else if (b2 == "US%206%20Big%20Kid") {
      b2 = "40";
    }
    else if (b2 == "US%206.5%20Big%20Kid") {
      b2 = "41";
    }
    else if (b2 == "US%207%20Big%20Kid") {
      b2 = "42";
    }
    else if (b2 == "US%207.5%20Big%20Kid") {
      b2 = "43";
    }
    else if (b2 == "Newborn") {
      b2 = "0000";
    }
    else if (b2 == "0-3%20Months") {
      b2 = "0001";
    }
    else if (b2 == "3-6%20Months") {
      b2 = "0002";
    }
    else if (b2 == "6-9%20Months") {
      b2 = "0003";
    }
    else if (b2 == "9-12%20Months") {
      b2 = "0004";
    }
    else if (b2 == "12-18%20Months") {
      b2 = "0005";
    }
    else if (b2 == "18-24%20Months") {
      b2 = "0006";
    }
    else if (b2 == "US%201T") {
      b2 = "US%20001";
    }
    else if (b2 == "US%202T") {
      b2 = "US%20002";
    }
    else if (b2 == "US%203T") {
      b2 = "US%20003";
    }
    else if (b2 == "US%204T") {
      b2 = "US%20004";
    }
    else if (b2 == "US%205T") {
      b2 = "US%20005";
    }
    else if (b2 == "US%206T") {
      b2 = "US%20006";
    }
    else if (b2.startsWith("US%2000%20")) {
      b2 = "US%200000";
    }
    else if (b2.startsWith("US%200%20")) {
      b2 = "US%200001";
    }
    else if (b2.startsWith("US%201%20") || b2 == "US%201") {
      b2 = "US%2001";
    }
    else if (b2.startsWith("US%201.5%20") || b2 == "US%201.5") {
      b2 = "US%2001.5";
    }
    else if (b2.startsWith("US%202%20") || b2 == "US%202") {
      b2 = "US%2002";
    }
    else if (b2.startsWith("US%202.5%20") || b2 == "US%202.5") {
      b2 = "US%2002.5";
    }
    else if (b2.startsWith("US%203%20") || b2 == "US%203") {
      b2 = "US%2003";
    }
    else if (b2.startsWith("US%203.5%20") || b2 == "US%203.5") {
      b2 = "US%2003.5";
    }
    else if (b2.startsWith("US%204%20") || b2 == "US%204") {
      b2 = "US%2004";
    }
    else if (b2.startsWith("US%204.5%20") || b2 == "US%204.5") {
      b2 = "US%2004.5";
    }
    else if (b2.startsWith("US%205%20") || b2 == "US%205") {
      b2 = "US%2005";
    }
    else if (b2.startsWith("US%205.5%20") || b2 == "US%205.5") {
      b2 = "US%2005.5";
    }
    else if (b2.startsWith("US%206%20") || b2 == "US%206") {
      b2 = "US%2006";
    }
    else if (b2.startsWith("US%206.5%20") || b2 == "US%206.5") {
      b2 = "US%2006.5";
    }
    else if (b2.startsWith("US%207%20") || b2 == "US%207") {
      b2 = "US%2007";
    }
    else if (b2.startsWith("US%207.5%20") || b2 == "US%207.5") {
      b2 = "US%2007.5";
    }
    else if (b2.startsWith("US%208%20") || b2 == "US%208") {
      b2 = "US%2008";
    }
    else if (b2.startsWith("US%208.5%20") || b2 == "US%208.5") {
      b2 = "US%2008.5";
    }
    else if (b2.startsWith("US%209%20") || b2 == "US%209") {
      b2 = "US%2009";
    }
    else if (b2.startsWith("US%209.5%20") || b2 == "US%209.5") {
      b2 = "US%2009.5";
    }
    else if (b2.startsWith("UK%201")) {
      b2 = "UT%2010";
    }
    else if (b2.startsWith("UK%2000%20")) {
      b2 = "UT%200";
    }
    else if (b2.startsWith("UK%200%20")) {
      b2 = "UT%2000";
    }
    else if (b2.startsWith("UK%201%20") || b2 == "UK%201") {
      b2 = "UT%2001";
    }
    else if (b2.startsWith("UK%201.5%20") || b2 == "UK%201.5") {
      b2 = "UT%2001.5";
    }
    else if (b2.startsWith("UK%202%20") || b2 == "UK%202") {
      b2 = "UT%2002";
    }
    else if (b2.startsWith("UK%202.5%20") || b2 == "UK%202.5") {
      b2 = "UT%2002.5";
    }
    else if (b2.startsWith("UK%203%20") || b2 == "UK%203") {
      b2 = "UT%2003";
    }
    else if (b2.startsWith("UK%203.5%20") || b2 == "UK%203.5") {
      b2 = "UT%2003.5";
    }
    else if (b2.startsWith("UK%204%20") || b2 == "UK%204") {
      b2 = "UT%2004";
    }
    else if (b2.startsWith("UK%204.5%20") || b2 == "UK%204.5") {
      b2 = "UT%2004.5";
    }
    else if (b2.startsWith("UK%205%20") || b2 == "UK%205") {
      b2 = "UT%2005";
    }
    else if (b2.startsWith("UK%205.5%20") || b2 == "UK%205.5") {
      b2 = "UT%2005.5";
    }
    else if (b2.startsWith("UK%206%20") || b2 == "UK%206") {
      b2 = "UT%2006";
    }
    else if (b2.startsWith("UK%206.5%20") || b2 == "UK%206.5") {
      b2 = "UT%2006.5";
    }
    else if (b2.startsWith("UK%207%20") || b2 == "UK%207") {
      b2 = "UT%2007";
    }
    else if (b2.startsWith("UK%207.5%20") || b2 == "UK%207.5") {
      b2 = "UT%2007.5";
    }
    else if (b2.startsWith("UK%208%20") || b2 == "UK%208") {
      b2 = "UT%2008";
    }
    else if (b2.startsWith("UK%208.5%20") || b2 == "UK%208.5") {
      b2 = "UT%2008.5";
    }
    else if (b2.startsWith("UK%209%20") || b2 == "UK%209") {
      b2 = "UT%2009";
    }
    else if (b2.startsWith("UK%209.5%20") || b2 == "UK%209.5") {
      b2 = "UT%2009.5";
    }
    else if (b2.startsWith("UK%2032%20") || b2 == "UK%2032") {
      b2 = "UT%2010";
    }      
    else if (b2.startsWith("EU%2016%20") || b2 == "EU%2016") {
      b2 = "UU%2016";
    }
    else if (b2.startsWith("EU%2017%20") || b2 == "EU%2017") {
      b2 = "UU%2017";
    }
    else if (b2.startsWith("EU%2018%20") || b2 == "EU%2018") {
      b2 = "UU%2018";
    }
    else if (b2.startsWith("EU%2019%20") || b2 == "EU%2019") {
      b2 = "UU%2019";
    }
    else if (b2.startsWith("EU%2020%20") || b2 == "EU%2020") {
      b2 = "UU%2020";
    }
    else if (b2.startsWith("EU%2021%20") || b2 == "EU%2021") {
      b2 = "UU%2021";
    }
    else if (b2.startsWith("EU%2022%20") || b2 == "EU%2022") {
      b2 = "UU%2022";
    }
    else if (b2.startsWith("EU%2023%20") || b2 == "EU%2023") {
      b2 = "UU%2023";
    }
    else if (b2.startsWith("EU%2024%20") || b2 == "EU%2024") {
      b2 = "UU%2024";
    }
    else if (b2.startsWith("EU%2025%20") || b2 == "EU%2025") {
      b2 = "UU%2025";
    }
    else if (b2.startsWith("EU%2026%20") || b2 == "EU%2026") {
      b2 = "UU%2026";
    }
    else if (b2.startsWith("EU%2027%20") || b2 == "EU%2027") {
      b2 = "UU%2027";
    }
    else if (b2.startsWith("EU%2028%20") || b2 == "EU%2028") {
      b2 = "UU%2028";
    }
    else if (b2.startsWith("EU%2029%20") || b2 == "EU%2029") {
      b2 = "UU%2029";
    }
    else if (b2.startsWith("EU%2030%20") || b2 == "EU%2030") {
      b2 = "UU%2030";
    }
    else if (b2.startsWith("EU%2031%20") || b2 == "EU%2031") {
      b2 = "UU%2031";
    }      
    else if (b2.startsWith("EU%2032%20") || b2 == "EU%2032") {
      b2 = "UU%2032";
    }
    else if (b2.startsWith("EU%2033%20") || b2 == "EU%2033") {
      b2 = "UU%2033";
    }
    else if (b2.startsWith("EU%2033.5%20") || b2 == "EU%2033.5") {
      b2 = "UU%2033.5";
    }
    else if (b2.startsWith("EU%2034%20") || b2 == "EU%2034") {
      b2 = "UU%2034";
    }
    else if (b2.startsWith("EU%2034.5%20") || b2 == "EU%2034.5") {
      b2 = "UU%2034.5";
    }
    else if (b2.startsWith("EU%2035") || b2 == "EU%2035") {
      b2 = "UU%2035";
    }
    else if (b2.startsWith("EU%2035.5%20") || b2 == "EU%2035.5") {
      b2 = "UU%2035.5";
    }
    else if (b2.startsWith("EU%2036") || b2 == "EU%2036") {
      b2 = "UU%2036";
    }
    else if (b2.startsWith("EU%2036%2F37") || b2 == "EU%2036%2F37") {
      b2 = "UU%2036.1";
    }
    else if (b2.startsWith("EU%2036.5%20") || b2 == "EU%2036.5") {
      b2 = "UU%2036.5";
    }
    else if (b2.startsWith("EU%2037") || b2 == "EU%2037") {
      b2 = "UU%2037";
    }
    else if (b2.startsWith("EU%2037%2F38") || b2 == "EU%2037%2F38") {
      b2 = "UU%2037.1";
    }
    else if (b2.startsWith("EU%2037.5%20") || b2 == "EU%2037.5") {
      b2 = "UU%2037.5";
    }
    else if (b2.startsWith("EU%2038") || b2 == "EU%2038") {
      b2 = "UU%2038";
    }
    else if (b2.startsWith("EU%2038.5%20") || b2 == "EU%2038.5") {
      b2 = "UU%2038.5";
    }
    else if (b2.startsWith("EU%2039") || b2 == "EU%2039") {
      b2 = "UU%2039";
    }
    else if (b2.startsWith("EU%2039.5%20") || b2 == "EU%2039.5") {
      b2 = "UU%2039.5";
    }
    else if (b2.startsWith("EU%2040") || b2 == "EU%2040") {
      b2 = "UU%2040";
    }
    else if (b2.startsWith("EU%2040.5%20") || b2 == "EU%2040.5") {
      b2 = "UU%2040.5";
    }
    else if (b2.startsWith("EU%2041") || b2 == "EU%2041") {
      b2 = "UU%2041";
    }
    else if (b2.startsWith("EU%2041.5%20") || b2 == "EU%2041.5") {
      b2 = "UU%2041.5";
    }
    else if (b2.startsWith("EU%2042") || b2 == "EU%2042") {
      b2 = "UU%2042";
    }
    else if (b2.startsWith("EU%2042.5%20") || b2 == "EU%2042.5") {
      b2 = "UU%2042.5";
    }
    else if (b2.startsWith("EU%2043") || b2 == "EU%2043") {
      b2 = "UU%2043";
    }
    else if (b2.startsWith("EU%2043.5%20") || b2 == "EU%2043.5") {
      b2 = "UU%2043.5";
    }
    else if (b2.startsWith("EU%2044") || b2 == "EU%2044") {
      b2 = "UU%2044";
    }
    else if (b2.startsWith("EU%2044.5%20") || b2 == "EU%2044.5") {
      b2 = "UU%2044.5";
    }
    else if (b2.startsWith("EU%2045") || b2 == "EU%2045") {
      b2 = "UU%2045";
    }
    else if (b2.startsWith("EU%2045.5%20") || b2 == "EU%2045.5") {
      b2 = "UU%2045.5";
    }
    else if (b2.startsWith("EU%2046") || b2 == "EU%2046") {
      b2 = "UU%2046";
    }
    else if (b2.startsWith("EU%2046.5%20") || b2 == "EU%2046.5") {
      b2 = "UU%2046.5";
    }
    else if (b2.startsWith("EU%2047") || b2 == "EU%2047") {
      b2 = "UU%2047";
    }
    else if (b2.startsWith("EU%2048") || b2 == "EU%2048") {
      b2 = "UU%2048";
    }
    else if (b2.startsWith("EU%2049") || b2 == "EU%2049") {
      b2 = "UU%2049";
    }
    else if (b2.startsWith("EU%2050") || b2 == "EU%2050") {
      b2 = "UU%2050";
    }
    else if (b2 == "One%20Size") {
      b2 = "x1898";
    }
    else if (b2 == "XXS") {
      b2 = "x1900";
    }
    else if (b2 == "XS") {
      b2 = "x1902";
    }
    else if (b2 == "S") {
      b2 = "x1904";
    }
    else if (b2 == "M") {
      b2 = "x1906";
    }
    else if (b2 == "L") {
      b2 = "x1908";
    }
    else if (b2 == "XL") {
      b2 = "x1910";
    }
    else if (b2 == "XXL") {
      b2 = "x1912";
    }
    else if (b2 == "XXXL") {
      b2 = "x1914";
    }
    else if (b2 == "XXXSmall") {
      b2 = "x1916";
    }
    else if (b2 == "XXSmall") {
      b2 = "x1918";
    }
    else if (b2 == "XSmall") {
      b2 = "x1920";
    }
    else if (b2 == "XSmall%2FSmall") {
      b2 = "x1921";
    }
    else if (b2 == "Small") {
      b2 = "x1922";
    }
    else if (b2 == "Small%2FMedium") {
      b2 = "x2012";
    }
    else if (b2 == "Medium") {
      b2 = "x2013";
    }
    else if (b2 == "Medium%2FLarge") {
      b2 = "x2014";
    }
    else if (b2 == "Large") {
      b2 = "x2015";
    }
    else if (b2 == "Large%2FXLarge") {
      b2 = "x2016";
    }
    else if (b2 == "Extra%20Large") {
      b2 = "x2018";
    }
    else if (b2 == "XLarge") {
      b2 = "x2019";
    }
    else if (b2 == "XLarge%20Short") {
      b2 = "x2019";
    }
    else if (b2 == "XLarge%20Tall") {
      b2 = "x2020";
    }
    else if (b2 == "XXLarge") {
      b2 = "x2021";
    }
    else if (b2 == "XXLarge%20Tall") {
      b2 = "x2022";
    }
    else if (b2 == "XXXLarge") {
      b2 = "x2023";
    }
    else if (b2 == "XXXLarge%20Tall") {
      b2 = "x2024";
    }
    else if (b2 == "4XLarge") {
      b2 = "x2025";
    }
    else if (b2 == "4XLarge%20Tall") {
      b2 = "x2026";
    }
    else if (b2.startsWith("Plus")) {
      b2 = "x2028";
    }
    else if (b2 == "Petite%20XSmall") {
      b2 = "x2030";
    }
    else if (b2 == "Petite%20Small") {
      b2 = "x2032";
    }
    else if (b2 == "Petite%20Medium") {
      b2 = "x2034";
    }
    else if (b2 == "Petite%20Large") {
      b2 = "x2036";
    }
    else if (b2 == "Petite%20XLarge") {
      b2 = "x2037";
    }
    else if (b2 == "$50.00" || b2 == "$75.00" || b2 == "$100.00" || b2 == "$125.00" || b2 == "$150.00" || b2 == "$175.00" || b2 == "$200.00" || b2 == "$250.00" || b2 == "$300.00") {
      b2 = parseInt(b2.split('$')[1]);
    }
    
    if (a2.toLowerCase() < b2.toLowerCase()) { return -1; }
    if (a2.toLowerCase() > b2.toLowerCase()) { return 1; }
    return 0;
  }).appendTo(el);
}

$(document).ready(function() {
  $("#qDesktop[name='q']").prop('disabled', false);
  
  if (window.innerWidth < 767) {
    if ($("#qDesktop[name='q']").val() !== '') { 
      $("#qMobile[name='q']").val($("#qDesktop[name='q']").val());
    }

    $(".site-header__search-form").click(function(e) {
      $("#qDesktop[name='q']").blur();
      $("#qDesktop[name='q']").prop('disabled', true);

      setTimeout(function() {
        $("#qMobile[name='q']").get(0).focus();
      }, 0)
    });

    const checkBanner = setInterval(function (){
      if ($('#branch-banner-iframe').height()) {
       $('#mobileSearchPanel').css('top', $('#branch-banner-iframe').height());
      } else {
       $('#mobileSearchPanel').css('top', '0');
        clearInterval(checkBanner);
      }
    }, 2000);
  }
  
  $(".site-header__search-btn").click(function () {
    let v = $(this).parent().find(".site-header__search-input").val();
    
    if (v == "" || v.indexOf("<script") > -1)
      return false;
    $("#searchPopParent").hide();
    $(".gray-overlay").hide();
    $(".close-search").hide();
    $(".close-search-mobile").hide();
    $(".search-mag-icon").show();
    setLocalStorageRecentSearch(v,"term");

    if (window.innerWidth < 767) {
      v = $(this).parent().find(".site-header__search-input-mobile").val();
      $(this).parent().parent().find(".site-header__search-form-mobile").submit();
    } else {
      $(this).parent().parent().find(".site-header__search-form").submit();   
    }
  });

  $("#qDesktop[name='q'], #qMobile[name='q']").keyup(function (event) {
    let v = $(this).val();
    if (v == "") {
      $(".close-search-mobile").hide();
      $("#searchPopParent").hide();
      recentSearchesLoad();
      $("#shoppingAssistantSuggest").show();
      $("#imageSearchSuggest").show();
      $("#colorPickSuggest").show();
      $("#searchSuggestionsMobile > #shoppingAssistantSuggest").show();
      $("#searchSuggestionsMobile > #imageSearchSuggest").show();
      $("#searchSuggestionsMobile > #colorPickSuggest").show();
      return false;
    }
    else if (v.indexOf("<script") > -1) {
      return false;
    }
    switch (event.which) {
      //left,right,delete,backspace
      case 37:
      case 39:
        return;
      case 13: //enter
        $("#searchPopParent").hide();
        $(".gray-overlay").hide();
        $(".close-search").hide();
        $(".close-search-mobile").hide();
        $(".search-mag-icon").show();
        setLocalStorageRecentSearch($(this).val(),"term");
        return;
      case 38: // Up arrow
        if (searchcurrentLI == -1)
          return;
        suggestlistItems[searchcurrentLI].classList.remove("highlight");
        searchcurrentLI = searchcurrentLI > 0 ? --searchcurrentLI : 0;
        suggestlistItems[searchcurrentLI].classList.add("highlight");
        $(this).val(suggestlistItems[searchcurrentLI].dataset.value);
        return;
      case 40: // Down arrow
        if (searchcurrentLI >= 0)
          suggestlistItems[searchcurrentLI].classList.remove("highlight");
        searchcurrentLI = searchcurrentLI < suggestlistItems.length - 1 ? ++searchcurrentLI : suggestlistItems.length - 1;
        suggestlistItems[searchcurrentLI].classList.add("highlight");
        $(this).val(suggestlistItems[searchcurrentLI].dataset.value);
        return;
    }
    if (searchSuggestTimeout == 0) {
      searchSuggestTimeout = 1;
      searchTimeout = setTimeout(function () {
        if (v != "") {
          $(".close-search-mobile").show();
          autoComplete(v);
        }
        else {
          recentSearchesLoad();
        }
        searchSuggestTimeout = 0;
      }, 100);
    }
  });
});